/** ---- Dispatch Types ---- */
export const NEW_EHEALTH_PASSWORD = "NEW_EHEALTH_PASSWORD";

/** ---- Dispatch Interfaces ---- */
interface NewEHealthPassword {
  type: typeof NEW_EHEALTH_PASSWORD;
  payload: string;
}

export type SessionAction = NewEHealthPassword;
